
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/
import * as React from 'react';

export interface ICheckoutLoyaltyLabelProps {
    className: string;
    text: string;
    htmlFor: string;
}

/**
 *
 * AddPaymentForm SFC
 * @extends {React.FC<ICheckoutLoyaltyLabelProps>}
 */
const CheckoutLoyaltyLabel: React.FC<ICheckoutLoyaltyLabelProps> = ({
    className,
    text,
    htmlFor
}) => {

    return <label className={className} htmlFor={htmlFor}>{text}</label>;
};

export default CheckoutLoyaltyLabel;